import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/theme/mountex/footer_tree.png")